function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortableWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.88,32.88H18.2a1.21,1.21,0,0,1-.84-.33,1,1,0,0,1-.34-.79,9,9,0,0,1,4.65-7.49l8-4.62a.83.83,0,0,0,.43-.71V16A1.13,1.13,0,0,1,31.3,15h8.48A1.13,1.13,0,0,1,41,16v2.91a.81.81,0,0,0,.42.7l8,4.63a9,9,0,0,1,4.64,7.49,1,1,0,0,1-.33.79A1.24,1.24,0,0,1,52.88,32.88ZM19.51,30.71H51.57a6.91,6.91,0,0,0-3.41-4.6l-8-4.62a2.94,2.94,0,0,1-1.54-2.55V17.12H32.48v1.82a2.94,2.94,0,0,1-1.54,2.55l-8,4.62A7,7,0,0,0,19.51,30.71Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.89,46.62H18.2A1.14,1.14,0,0,1,17,45.53V36.44a1.14,1.14,0,0,1,1.18-1.09H52.89a1.14,1.14,0,0,1,1.18,1.09v9.09A1.14,1.14,0,0,1,52.89,46.62ZM19.38,44.44H51.71V37.52H19.38Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.02,
    y: 50.18,
    width: 2.36,
    height: 9.09,
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.94 71.46h-22.8a6.86 6.86 0 0 1-7.14-6.55v-1h2.36v1a4.59 4.59 0 0 0 4.76 4.38h22.8a4.93 4.93 0 0 0 3.87-1.82l1.91 1.27a7.32 7.32 0 0 1-5.76 2.72z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78,17.12H31.3A1.14,1.14,0,0,1,30.12,16V11.46a1.14,1.14,0,0,1,1.18-1.09h8.48A1.13,1.13,0,0,1,41,11.46V16A1.13,1.13,0,0,1,39.78,17.12ZM32.48,15H38.6V12.54H32.48Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.55,37.52h-36a2.83,2.83,0,0,1-2.94-2.7V33.41a2.83,2.83,0,0,1,2.94-2.7h36a2.82,2.82,0,0,1,2.93,2.7v1.41A2.82,2.82,0,0,1,53.55,37.52Zm-36-4.64a.56.56,0,0,0-.58.53v1.41a.56.56,0,0,0,.58.53h36a.56.56,0,0,0,.57-.53V33.41a.56.56,0,0,0-.57-.53Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.29,51.26H17.54a2.83,2.83,0,0,1-2.94-2.7V47.15a2.84,2.84,0,0,1,2.94-2.71H52.89v2.18H17.54a.55.55,0,0,0-.58.53v1.41a.56.56,0,0,0,.58.53H50.29Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1,65H17.54a2.83,2.83,0,0,1-2.94-2.7V60.88a2.83,2.83,0,0,1,2.94-2.7H47.77v2.17H17.54a.56.56,0,0,0-.58.53V62.3a.56.56,0,0,0,.58.53H48.1Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.36,61c0,5-3.49,11.64-12.1,11.64S46.16,66,46.16,61c0-8.71,12.1-20.73,12.1-20.73S70.36,52.29,70.36,61Z",
    style: {
      fill: "#fff",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,67.82a6.88,6.88,0,0,1-5.59-.51,6.5,6.5,0,0,1-3.67-4.11",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.7px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortableWater);
export default __webpack_public_path__ + "static/media/portable_water.e202d6d04633d06f3602b8363a95ae2b.svg";
export { ForwardRef as ReactComponent };